import React, { Component } from 'react'
import cookie from 'react-cookies'

// STYLES
import styled from 'styled-components'

export default class Cookies extends Component {
    setApproved = () => {
      cookie.save('approved', true)
      this.props.setApproved()
    }

    formatDoc () {
      if (this.props.i18n.language === 'pt') {
        return 'https://quality-ahresp.ubiwhere.com/filer/sharing/1528199154/26588/'
      } else if (this.props.i18n.language === 'en') {
        return 'https://quality-ahresp.ubiwhere.com/filer/sharing/1528206101/26589/'
      } else {
        return 'https://quality-ahresp.ubiwhere.com/filer/sharing/1528206101/26589/'
      }
    }

    render () {
      const t = this.props.t

      return (
        <Wrapper>
          <Content>
            <Text>
              {t('Os cookies ajudam-nos a melhorar a sua experiência de navegação. Ao utilizar o portal Taste Portugal, concorda com a utilização de cookies.')}<a href={this.formatDoc()} target='_blank'>{t('Ler mais')}</a>
            </Text>
            <Button onClick={this.setApproved}>
              {t('CONCORDO')}
            </Button>
          </Content>
        </Wrapper>
      )
    }
}

const Wrapper = styled.div`
    position: fixed;
    z-index: 10000;
    bottom: 0;
    width: 100%;
    background-color: #2E84C6;
`
const Content = styled.div`
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 30px;
    padding-bottom: 30px;
`
const Text = styled.div`
    color: #FFF;
    text-align: center;
    margin-bottom: 20px;
    font-size: 14px;
    font-family: Dosis;

    a {
        color: #FFF;
        font-weight: 600;
        text-decoration: underline;
        margin-left: 4px;
        font-family: Dosis;
    }
`
const Button = styled.div`
    width: 100px;
    text-align: center;
    background-color: #FFF;
    color: #2E84C6;
    border-radius: 3px;
    padding: 10px 10px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.3s ease;
    font-family: Dosis;
    margin-left: auto;
    margin-right: auto;
    font-size: 14px;
`



// WEBPACK FOOTER //
// ./src/components/cookies/cookies.component.js